// Returned by uv.device.live.api. Transport null = no live source.
export type LiveTransport = 'mpeg1' | 'webrtc';

export interface DeviceLiveDescriptor {
  Transport: LiveTransport | null;
  Url: string | null;
}

// Fallback on error, so callers land on their existing "no Url" branch instead
// of leaving the player pending.
export const NO_LIVE_DESCRIPTOR: DeviceLiveDescriptor = { Transport: null, Url: null };

// Both live endpoints of a token live under /api/live/<token>/: the descriptor
// carries the signaling one, the MSE fallback is its sibling.
export function mseFallbackUrl(signalingUrl: string): string {
  return signalingUrl
    .replace(/^http/, 'ws')
    .replace(/\/webrtc(?=$|[?#])/, '/ws');
}
